export default {
  okText: 'Ok',
  dismissText: 'Cancel',
  extra: 'please select'
}



// WEBPACK FOOTER //
// ./src/components/picker/locale/en_US.js